import { AdresseForm } from '@mairistem/adresses';

import type { AdresseType } from '@/types';

interface PayeurAdresseListItemFormProps {
  adresse: AdresseType;
  onChange: (e) => void;
}

const PayeurAdresseListItemForm = (props: PayeurAdresseListItemFormProps) => {
  const { adresse, onChange } = props;

  return (
    <AdresseForm
      adresse={adresse}
      onChange={onChange}
      onItemChange={(data) => {
        onChange({ target: { name: 'adresse', value: data?.adresse } });
      }}
    />
  );
};

export default PayeurAdresseListItemForm;
